import { FC } from 'react'

import styled from 'styled-components'

import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useAppSelector } from 'src/Hooks/redux'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { getScheduledTikTokCampaignComment } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { ModalType } from 'src/Types/ui'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const Comment = styled(SubTitle)`
  font-weight: 400;
`
export const Expectations: FC = () => {
  const comment = useAppSelector(getScheduledTikTokCampaignComment)

  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Comment,
    }
    setSearch(query)
  }
  if (!comment) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>Add task for creators</span>
      </AddParameterButton>
    )
  }
  return (
    <Container>
      <Wrapper>
        <SubTitle>Task for creators</SubTitle>
        <Comment>{comment}</Comment>
      </Wrapper>
      <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
    </Container>
  )
}
